<div class="card">
  <div class="card-body">
    <div class="d-flex align-items-center">
      <div class="subheader">@if (iconSvg) { <app-dashboard-icon [svg]="iconSvg" class="me-2"></app-dashboard-icon> } {{ title }}</div>
      <div class="ms-auto lh-1 range-control">
        @if (showTimeWindowPicker) {
          <button type="button" class="btn btn-link btn-sm dropdown-toggle text-secondary p-0" [attr.aria-expanded]="rangeOpen" (click)="rangeOpen = !rangeOpen">{{ selectedWindow.label }}</button>
          @if (rangeOpen) {
            <div class="dropdown-menu dropdown-menu-end show">
              @for (option of timeWindowOptions; track option.label; let index = $index) {
                <button type="button" class="dropdown-item" [class.active]="index === selectedWindowIndex" (click)="selectWindow(index)">{{ option.label }}</button>
              }
            </div>
          }
        } @else if (displayedWindowLabel) {
          <span class="text-secondary small">{{ displayedWindowLabel }}</span>
        }
      </div>
    </div>

    @if (loading) {
      <div class="widget-loading"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span>Loading report…</div>
    } @else if (error) {
      <div class="widget-error mt-2" role="alert">{{ error }}</div>
    } @else if (presentation === 'radial') {
      <div class="radial-layout">
        <div class="h1 mb-0">{{ value | number:'1.0-1' }}%</div>
        <div class="radial" [style.--percentage]="boundedValue" role="progressbar" [attr.aria-valuenow]="boundedValue" aria-valuemin="0" aria-valuemax="100">
          <span>{{ boundedValue | number:'1.0-0' }}%</span>
        </div>
      </div>
    } @else {
      <div class="h1 mb-3">{{ value | number:'1.0-1' }}%</div>
      <div class="d-flex mb-2">
        <div>{{ caption }}</div>
        @if (changeQuery) {
          <div class="ms-auto">
            <span class="d-inline-flex align-items-center lh-1" [class.text-green]="change > 0" [class.text-red]="change < 0" [class.text-yellow]="change === 0">
              {{ change | number:'1.0-1' }}%
              <svg class="icon ms-1 icon-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                @if (change > 0) { <path d="M3 17l6-6 4 4 8-8"></path><path d="M14 7h7v7"></path> }
                @else if (change < 0) { <path d="M3 7l6 6 4-4 8 8"></path><path d="M21 10v7h-7"></path> }
                @else { <path d="M5 12h14"></path> }
              </svg>
            </span>
          </div>
        }
      </div>
      <div class="progress progress-sm">
        <div class="progress-bar" [style.width.%]="boundedValue" role="progressbar" [attr.aria-valuenow]="boundedValue" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    }
  </div>
</div>
